import React, { Component } from "react"
import PropTypes from "prop-types"

import InputField from "./InputField"
import styles from "./TextChoice.module.sass"
import { v4 } from "uuid"

class TextChoice extends Component {
  static propTypes = {
    choices: PropTypes.object,
    doneCallback: PropTypes.func,
    type: PropTypes.string,
    labels: PropTypes.object,
    stepName: PropTypes.string,
    theme: PropTypes.object.isRequired,
    kmPlaceholder: PropTypes.string,
    locale: PropTypes.string,
    selected: PropTypes.object,
    onSelectedUpdate: PropTypes.func,
    buttonText: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.id = `text-choice-${v4()}`
  }

  state = {
    value: { ...(this.props.selected || this.props.choices) },
  }

  done = () => {
    this.props.doneCallback(this.state.value)
  }

  valueChanged = (value) => {
    this.setState((prevState) => {
      const newValue = { [Object.keys(prevState.value)]: value }

      // Call the prop function when the value changes
      this.props.onSelectedUpdate &&
        this.props.onSelectedUpdate(this.props.stepName, newValue)
      return { value: newValue }
    })
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.done()
  }

  render() {
    const { labels } = this.props
    const buttonStyle = {
      backgroundColor: this.props.theme.color,
      border: `1px solid ${this.props.theme.color}`,
    }
    const inputValue = this.state.value[Object.keys(this.state.value)[0]]
    return (
      <div
        className={`${styles.outerContainer} ${this.props.kmPlaceholder ? styles.withPlaceholder : ""
          }`}
      >
        {inputValue !== "" &&
          inputValue != null &&
          this.props.kmPlaceholder && (
            <div className={styles.placeholder}>{this.props.kmPlaceholder}</div>
          )}
        {this.props.label && <label className={styles.label} htmlFor={this.id}>{this.props.label}</label>}
        <div className={styles.container}>
          <InputField
            id={this.id}
            type={this.props.type || "text"}
            value={inputValue}
            locale={this.props.locale}
            onChange={this.valueChanged}
            onKeyDown={this.handleKeyDown}
            openRight
            autoFocus
            inputPlaceholder={
              this.props.kmPlaceholder
                ? this.props.kmPlaceholder
                : labels.placeholders[this.props.stepName]
            }
          />
          <button
            type="button"
            onClick={this.done}
            style={buttonStyle}
            className={`secondary-cta ${styles.confirmButton}`}
          >
            {this.props.buttonText || "✓"}
          </button>
        </div>
      </div>
    )
  }
}

export default TextChoice
